import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setDeclineNewInvitationsEnabledState', (choice: boolean) => {
    let optionState = getStore().currentState;
    optionState.declineNewInvitationsEnabled = choice;
});
